import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
    Avatar,
    Backdrop,
    Box,
    Chip,
    CircularProgress,
    MenuItem,
    Select,
    Stack,
    Tooltip,
    Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useRef, useState } from "react";
import DeleteIcon from "../../assets/images/icons/X.svg";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../hooks/use.debounce";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AutoSuggestion from "../../components/autocomplete";
import CommonModel from "../../components/dialog/Common";
import { getFormatedDate } from "../../utils/common";
import { CREATOR_CATEGORY, CREATOR_GENDER, CUSTOM_PAPER_COMPONENT_FOR_AUTO_SUGGEST, CustomSearchInput, FOLLOWERS_ARRAY, FORM_SELECTFIELD_STYLES, getFixedValue, PENDING, SOCIAL_PLATFORM, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES, USER_STATUS_FILTER } from "../../utils/constant";
import { ROUTES } from "../../utils/routes";
import { deleteCreator, getAllCreator, getStateAndCity } from "./action";
import { updateUser } from "./userSlice";
import CustomPagination from "../../utils/CustomPagination";

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler =
        (property) => (event) => {
            if (property === "date") {
                onRequestSort(event, property);
            }
            return;
        };
    const headCells = [
        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "Name",
            type: "",
        },
        {
            id: "username",
            numeric: false,
            disablePadding: true,
            label: "Username",
            type: "",
        },
        {
            id: "niches",
            numeric: false,
            disablePadding: true,
            label: "Niches",
            type: "",
        },
        {
            id: "followers",
            numeric: false,
            disablePadding: true,
            label: "Followers",
            type: "",
        },
        {
            id: "state",
            numeric: false,
            disablePadding: true,
            label: "State",
            type: "",
        },
        {
            id: "city",
            numeric: false,
            disablePadding: true,
            label: "City",
            type: "",
        },
        {
            id: "date",
            numeric: false,
            disablePadding: true,
            label: "Created Date-Time",
            type: "",
        },
        {
            id: "status",
            numeric: false,
            disablePadding: true,
            label: "Status",
            type: "",
        },
        {
            id: "action",
            numeric: false,
            disablePadding: true,
            label: "Action",
            type: "",
        },
    ];
    return (
        <TableHead className="hideActionSort">
            <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
                {headCells.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={"left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy == headCell.id ? order : false}
                            onClick={createSortHandler(headCell.id)}>
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}>
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}


export default function CreatorListing() {
    const navigate = useNavigate();
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("date");
    const [deleteOpen, setDeleteOpen] = useState(0);
    const states = useSelector((state) => state.app);
    const [openTooltipIndexes, setOpenTooltipIndexes] = useState([]);
    const tooltipRefs = useRef([]);
    const handleTooltipToggle = (cellIndex) => {
        setOpenTooltipIndexes(openTooltipIndexes.includes(cellIndex) ? [] : [cellIndex]);
    };
    const tableRef = useRef();
    const handleDocumentClick = (event) => {
        const clickedOutsideAllTooltips = tooltipRefs.current.every(ref => ref && !ref.contains(event.target));
        if (clickedOutsideAllTooltips) {
            setOpenTooltipIndexes([]);
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleDocumentClick);

        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []);


    const dispatch = useDispatch();
    const {
        limit,
        page,
        sort_key,
        totalPages,
        listing,
        filters,
        loader,
        cityStateList,
        totalCount
    } = useSelector((state) => state.userSlice);
    const debouncedSearch = useDebounce(filters.search, 500);

    const handleChangePerPage = (event, value) => {
        dispatch(updateUser({ limit: event.target.value, page: 0 }));
        dispatch(getAllCreator());
    };
    const handleChange = (value) => {
        dispatch(updateUser({ page: value - 1 }));
        dispatch(getAllCreator());
    };

    const handleRequestSort = (
        event,
        property
    ) => {
        const isAsc = orderBy === property && order === "asc";

        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        dispatch(
            updateUser({
                sort_type: isAsc ? "asc" : "desc",
                sort_key: property,
            }),
        );
        dispatch(getAllCreator());
    };

    useEffect(() => {
        if (debouncedSearch || filters.search == "")
            dispatch(getAllCreator());

    }, [debouncedSearch]);

    useEffect(() => {
        dispatch(getAllCreator());
        dispatch(getStateAndCity());
    }, []);

    const handleSearch = (event) => {
        dispatch(updateUser({ page: 0, filters: { ...filters, search: event.target.value } }));
    };

    const handleSearchClear = () => {

        dispatch(updateUser({ filters: { ...filters, search: "" } }));
        dispatch(getAllCreator());
    };

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Stack direction={"column"} gap={2}>
                <Stack
                    className="mainTitle  flex-wrap"
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    sx={{
                        minHeight: '42px', paddingX: '16px'
                    }}>
                    <Typography className="page-title" variant="h1">Creator Management
                    </Typography>
                    <button className="btnPrimary"
                        disabled={!states?.permissions?.users?.create}
                        onClick={() => navigate(ROUTES.CREATE_INFLUENCER)}>
                        Create User
                    </button>
                </Stack>
                <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2} sx={{ paddingX: '16px' }}>
                    <CustomSearchInput
                        className="inputSearch sContrl p-0"
                        value={filters.search}
                        placeholder={"Search here..."}
                        handleSearch={handleSearch}
                        clearSearch={handleSearchClear}
                        startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT}
                    />
                    <Stack direction="row" justifyContent="flex-end" alignItems="center" flexWrap="wrap" gap={2}>
                        <AutoSuggestion
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxWidth: '250px', width: '250px' }}
                            CustomPaperComponent={CUSTOM_PAPER_COMPONENT_FOR_AUTO_SUGGEST}

                            multiple={true}
                            required={false}
                            disableClearable={true}
                            value={filters?.location || []}
                            className="auto-chips-cover"
                            label={""}
                            onChange={(e, newValue) => {
                                dispatch(updateUser({ filters: { ...filters, location: newValue }, page: 0 }));
                                dispatch(getAllCreator());
                            }}
                            limitTags={1}
                            placeholder="State/City"
                            defaultValue={filters?.location || []}
                            id={`users-`}
                            size="small"
                            name="location"
                            options={cityStateList}
                            isOptionEqualToValue={(option, value) => {
                                if (
                                    value === "" ||
                                    option === "" ||
                                    value === option
                                )
                                    return option;
                            }}
                            getOptionLabel={(option) =>
                                option || ""
                            }

                            renderTags={(value, getTagProps) => {
                                if (!Array.isArray(value)) return null;
                                return value.map((option, index) => {
                                    return (
                                        <Chip
                                            key={option.option || option}
                                            label={<Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'white' }}>
                                                {option?.substring(0, 10) || option}
                                            </Typography>}
                                            {...getTagProps({ index })}
                                            sx={{
                                                background: 'black !important',
                                                borderRadius: '62px', border: '0px solid #CCCBCB',
                                                padding: "3px 8px", height: '32px'
                                            }}
                                            deleteIcon={<img src={DeleteIcon} style={{ filter: 'brightness(0) invert(1)', }} alt="delete icon" width={24} height={24} />} // Custom delete icon
                                        />
                                    )
                                })
                            }
                            }
                            renderOption={(props, option) => {
                                return (
                                    <>
                                        <li {...props} style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap', padding: '2px 8px', width: '100%', borderRadius: '0px', border: '0px solid #CCCBCB', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', gap: 2
                                        }}><Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#444141', }}>{option}</Typography></li>
                                    </>)
                            }}
                        />
                        <Select
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '200px', width: '200px' }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: "8px",
                                        mt: 1,
                                    },
                                },
                            }}
                            value={filters.followers || ''}
                            name="followers"
                            onChange={(e) => {
                                dispatch(updateUser({ filters: { ...filters, followers: e.target.value }, page: 0 }));
                                dispatch(getAllCreator());
                            }}
                            displayEmpty
                            defaultValue={""}
                        >
                            <MenuItem value="" disabled hidden>
                                Followers
                            </MenuItem>

                            <MenuItem value=" " >
                                Followers (All)
                            </MenuItem>

                            {FOLLOWERS_ARRAY.map((row) => (
                                <MenuItem key={row.value} value={row.value}>
                                    {row.label}
                                </MenuItem>
                            ))}
                        </Select>
                        <Select
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '150px', width: '150px' }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: "8px",
                                        mt: 1,
                                    },
                                },
                            }}
                            value={filters.platform || ""}
                            name="platform"
                            onChange={(e) => {
                                dispatch(updateUser({ filters: { ...filters, platform: e.target.value }, page: 0 }));
                                dispatch(getAllCreator());
                            }}
                            displayEmpty>
                            <MenuItem value="" disabled hidden>
                                Platform
                            </MenuItem>
                            <MenuItem value=" " >
                                Platform (All)
                            </MenuItem>
                            {SOCIAL_PLATFORM.map((item) => (
                                <MenuItem key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                        <Select
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '150px', width: '150px' }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: "8px",
                                        mt: 1,
                                    },
                                },
                            }}
                            value={filters?.status || ''}
                            name="status"
                            onChange={(e) => {

                                dispatch(updateUser({ filters: { ...filters, status: e.target.value }, page: 0 }));
                                dispatch(getAllCreator());
                            }} displayEmpty
                            defaultValue={filters?.status || ''}
                            justifyContent={"flex-end"}
                            className="upperCase"
                        >
                            <MenuItem value="" disabled hidden>
                                Status
                            </MenuItem>
                            <MenuItem value=" " >
                                Status (All)
                            </MenuItem>
                            {USER_STATUS_FILTER.map((v) => <MenuItem key={v} value={v} >
                                {v}
                            </MenuItem>)}
                        </Select>
                        <Select
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '150px', width: '150px' }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: "8px",
                                        mt: 1,
                                    },
                                },
                            }}
                            value={filters.gender || ''}
                            name="gender"
                            onChange={(e) => {
                                dispatch(updateUser({ filters: { ...filters, gender: e.target.value }, page: 0 }));
                                dispatch(getAllCreator());
                            }}
                            displayEmpty
                            defaultValue={""}>
                            <MenuItem value="" disabled hidden>
                                Gender
                            </MenuItem>
                            <MenuItem value=" " >
                                Gender (All)
                            </MenuItem>
                            {CREATOR_GENDER.map((name) => (
                                <MenuItem key={name} value={name}>
                                    {name}
                                </MenuItem>
                            ))}
                        </Select>
                        <Select
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '150px', width: '150px' }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: "8px",
                                        mt: 1,
                                    },
                                },
                            }}
                            value={filters.creatorCategory || ''}
                            name="creatorCategory"
                            onChange={(e) => {
                                dispatch(updateUser({ filters: { ...filters, creatorCategory: e.target.value }, page: 0 }));
                                dispatch(getAllCreator());
                            }}
                            displayEmpty
                            defaultValue={""}
                        >
                            <MenuItem value="" disabled hidden>
                                Category
                            </MenuItem>
                            <MenuItem value=" " >
                                Category (All)
                            </MenuItem>
                            {CREATOR_CATEGORY.map((name) => (
                                <MenuItem key={name} value={name}>
                                    {name}
                                </MenuItem>
                            ))}
                        </Select>
                        <Tooltip title="Refresh listing">
                            <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692' }}
                                onClick={() => {
                                    dispatch(updateUser({ filters: {} }))
                                    dispatch(getAllCreator());
                                }} />
                        </Tooltip>

                    </Stack>
                </Stack>


                <Box
                    sx={{
                        backgroundColor: '#fff',
                        transition: 'all .5s ease-in-out',
                        position: 'relative',
                        overflow: 'none',
                    }}>
                    <TableContainer ref={tableRef}>
                        <Table aria-label="sticky table">
                            <EnhancedTableHead
                                order={order}
                                orderBy={sort_key}
                                onRequestSort={handleRequestSort}
                                numSelected={0}
                                onSelectAllClick={function (

                                ) {
                                    throw new Error("Function not implemented.");
                                }}
                            />
                            <TableBody>
                                {listing && listing?.length ? (
                                    listing?.map((row, index) => {
                                        let username = row?.platforms?.map((v) => v?.username)?.filter((v) => v);
                                        let niches = row?.profileNiche ? JSON?.parse(row?.profileNiche)?.map((v) => v.option)?.toString() || "N/A" : "N/A";
                                        const cellTooltipIndex = index;
                                        const isOpen = openTooltipIndexes.includes(cellTooltipIndex);
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={row?.id}
                                                sx={TABLE_BODY_ROW_MUI_STYLES}
                                            >
                                                <TableCell component="td" scope="row" padding="none">
                                                    <Stack direction={"row"} >
                                                        <Avatar
                                                            alt="Remy Sharp"
                                                            src={row.picture}
                                                            sx={{ height: '35px', width: '35px', borderRadius: "50%" }}
                                                        />
                                                        <a target="_blank" rel="noreferrer" 
                                                            href={`/userManagement/details/${row.id}`}
                                                            className="text-decoration-none text-capitalize"
                                                            style={{ fontSize: '13px', fontWeight: '500', letterSpacing: '0px', marginLeft: '8px', position: "relative", top: 5 }}>
                                                            {row?.name || "N/A"}
                                                        </a>
                                                    </Stack>
                                                </TableCell>

                                                <TableCell component="td" scope="row" padding="none">

                                                    {username?.length > 0 ? username?.toString() : "N/A"}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {niches != null && niches.length > 20 ? (
                                                        <div >
                                                            <Tooltip
                                                                ref={ref => tooltipRefs.current[cellTooltipIndex] = ref}
                                                                title={niches}
                                                                PopperProps={{
                                                                    disablePortal: true,
                                                                }}
                                                                arrow={true}
                                                                open={isOpen}
                                                                disableFocusListener
                                                                disableTouchListener
                                                                disableInteractive
                                                            >
                                                                <span
                                                                    className="showhandCursor"
                                                                    onClick={() => handleTooltipToggle(cellTooltipIndex)}>
                                                                    {niches.slice(0, 20)}
                                                                </span>
                                                            </Tooltip>
                                                            {!isOpen && <Tooltip title={niches} arrow={true}>
                                                                <span className="showhandCursor">...</span>
                                                            </Tooltip>}
                                                        </div>
                                                    ) : (
                                                        <span>{niches}</span>
                                                    )}

                                                </TableCell >
                                                <TableCell component="td" scope="row" padding="none">
                                                    {row?.platforms?.map((v) => parseInt(v?.followers))?.filter((v) => v)?.length > 0 ? getFixedValue(row?.platforms?.map((v) => parseInt(v?.followers))?.filter((v) => v)?.reduce((a, b) => Math?.max(a, b))) : "N/A"}
                                                </TableCell>
                                                <TableCell component="td" scope="row" padding="none">
                                                    {row?.state?.trim() !== "null" && row?.state !== '' ? row?.state : "N/A"}
                                                </TableCell>
                                                <TableCell component="td" scope="row" padding="none">
                                                    {row?.city?.trim() !== "null" && row?.state !== '' ? row?.city : "N/A"}
                                                </TableCell>
                                                <TableCell component="td" scope="row" padding="none">
                                                    {row?.createdDate ? getFormatedDate(row?.createdDate?.toLocaleString(), "MM/DD/YYYY HH:mm:ss") : "N/A"}
                                                </TableCell>

                                                <TableCell align="left" className={`single-line `}>
                                                    <button className={row.status?.toLowerCase() + " capitalize-first-letter"}>{row.status}</button>
                                                </TableCell>
                                                <TableCell>
                                                    <div className="actBtnGrps">
                                                        {row.status !== PENDING ? <><span className="showhandCursor" onClick={() => {
                                                            window.open(`/editInfluencer/${row.id}`)
                                                        }}>
                                                            Edit
                                                        </span>
                                                            <span className="viewIcon" onClick={() => {
                                                                window.open(`/userManagement/details/${row.id}`)
                                                            }}>
                                                                View
                                                            </span>

                                                            <span className="viewIcon" style={{ color: "red" }} onClick={() => {
                                                                setDeleteOpen(row.id)
                                                            }}>
                                                                Delete
                                                            </span></> : <span className="viewIcon" onClick={() => {
                                                                window.open(`/userManagement/details/${row.id}`)
                                                            }}>
                                                            Verfiy
                                                        </span>}
                                                    </div>
                                                </TableCell>
                                            </TableRow >
                                        );
                                    })
                                ) : (
                                    <TableRow colSpan={11}>
                                        <TableCell colSpan={11} style={{ textAlign: 'center', height: "250px" }}>

                                            <Typography
                                                color="inherit"
                                                variant="subtitle1"
                                                alignItems={"center"}
                                                component="h3"
                                            >
                                                No Data found!
                                            </Typography>

                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody >
                        </Table >
                    </TableContainer>
                    <Stack
                        sx={{
                            background: 'transparent',
                            height: '60px',
                            border: '1px solid #E9EAEB'
                        }}
                        direction="row"
                        alignItems={"center"}
                        justifyContent={"flex-end"}>
                        <CustomPagination
                            count={Math.ceil(totalPages / limit) || 0}
                            onChange={handleChange}
                            currentPage={page}
                            handleChangePerPage={handleChangePerPage}
                            limit={limit}
                            listingCount={listing?.length}
                            totalCount={totalCount}
                            defaultPage={1} siblingCount={1} boundaryCount={1} />
                    </Stack>
                </Box >
            </Stack >
            <CommonModel
                open={deleteOpen}
                handleDialogClose={() => setDeleteOpen(false)}
                dialogTitle={"Delete Creator"}
                className={"btnDanger"}
                dialogPara={`Are you sure you want to delete this creator? `}
                nvYes={"Delete"}
                nvCancel={"Cancel"}
                yesHandle={() => {
                    dispatch(deleteCreator(deleteOpen));
                    setDeleteOpen(false);
                }}
            />
        </>
    );
}
